import React from 'react';
import { t } from 'ttag';
import { RiCloseLine } from 'react-icons/ri';
import { Heading } from 'components';
import PropTypes from 'prop-types';

function Header({ closeOverlay }) {
  return (
    <header className="flex items-center justify-between border-0 border-b border-solid border-white-smoke p-2 pl-4">
      <Heading as="h2" noMargin={true}>
        {t`Add customization`}
      </Heading>
      <button
        className="flex items-center border-0 bg-transparent p-4"
        type="button"
        aria-label={t`Close Customization Overlay`}
        onClick={() => closeOverlay()}
      >
        <RiCloseLine className="h-6 w-6 text-black" />
      </button>
    </header>
  );
}

Header.propTypes = {
  closeOverlay: PropTypes.func.isRequired,
};

Header.defaultProps = {};

export default Header;
